import keycloak from './keycloak'

const redirectToLogin = () => {
  keycloak.login({
    redirectUri: `${window.location.origin}/app?activateModule=true`,
  })
}

export { redirectToLogin }
